import styled, { css } from 'styled-components';
import ActionsGroup from '../../../../juristec-ui/core/ActionsGroup';

export const MainContainer = styled.div`
  display: grid;
  grid-template-areas:
    'toolbar toolbar'
    'sidebar form'
    'agroup agroup';
  grid-template-columns: 1fr 3fr;
  grid-template-rows: auto 1fr auto;
  height: calc(100vh - 180px);
  width: 60vw;
  max-width: 800px;
`;

export const ToolbarContainer = styled.div`
  grid-area: toolbar;
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  border-bottom: 2px solid ${({ theme }) => theme.card};
`;

export const ToolbarLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 10px 5px 10px;
  & > span {
    font-size: 14px;
    color: ${({ theme }) => theme.inputLabel};
    font-weight: bold;
    user-select: none;
    flex: 1 1;
    & + div {
      flex: 1 1;
    }
  }
  & svg {
    height: 15px;
    width: 15px;
  }
`;

export const ToolbarRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px 5px 10px;
  & svg {
    height: 20px;
    width: 20px;
    margin: 6px 5px 0 0;
    fill: ${({ theme }) => theme.grey};
  }
`;

export const SideBarContainer = styled.div`
  grid-area: sidebar;
  overflow: auto;
  box-sizing: border-box;
  border-right: 2px solid ${({ theme }) => theme.card};
`;

export const FormContainer = styled.div`
  grid-area: form;
  overflow: auto;
  padding: 5px 0;
  & hr:first-child {
    display: none;
  }
`;

export const ActionsGroupContainer = styled(ActionsGroup)`
  grid-area: agroup;
  box-sizing: border-box;
  border-top: 2px solid ${({ theme }) => theme.card};
`;

export const SeparatorLine = styled.hr`
  width: 80%;
  border: 0.8px solid ${({ theme }) => theme.card};
  margin: 10px auto;
`;

export const InputWrapperHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 5px 5px 10px 5px;
  box-sizing: border-box;
`;

export const InputWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 5px 10px;
  box-sizing: border-box;
  min-height: 40px;
  flex-wrap: wrap;
  ${({ disabled, theme }) => css`
    & > h5 {
      margin: 0;
      font-size: 14px;
      color: ${theme.inputLabel};
      font-weight: bold;
      user-select: none;
      & + * {
        justify-content: flex-end;
      }
      &.field-error-label {
        color: ${theme.error};
      }
    }
    &:hover {
      background-color: ${theme.card};
      & > h5 {
        color: ${theme.grey};
        &.field-error-label {
          color: ${theme.error};
        }
      }
    }
    ${disabled && css`
      opacity: 0.3;
      cursor: not-allowed;
      & * {
        pointer-events: none;
      }
    `}
    & span.field-error-msg {
      width: 100%;
      grid-column: 1 / span 2;
      text-align: right;
      font-size: 10px;
      padding-top: 2px;
      color: ${theme.error};
    }
  `}
  & .textAreaContainer {
    flex: 2 1;
    height: 120px;
  }
`;

export const FieldMapContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 0;

`;

export const FieldMapGroup = styled.button`
  display: flex;
  flex-direction: row;
  color: ${({ theme }) => theme.inputLabel};
  background-color: transparent;
  width: 100%;
  border: none;
  font-size: 18px;
  text-align: start;
  padding: 2px 5px 2px 0;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.card};
    color: ${({ theme }) => theme.grey};
  }
`;

export const IconFlipWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  & svg {
    width: 20px;
    height: 20px;
    fill: ${({ theme }) => theme.inputLabel}55;
  }
  transform: rotate(-90deg);
  ${({ flip }) => flip && css`
    transform: rotate(0deg);
  `}
`;

export const MapLines = styled.div`
  width: 10px;
  margin-left: -10px;
  border-left: 2px solid ${({ theme }) => theme.inputLabel}55;
  box-sizing: border-box;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    border-bottom: 2px solid ${({ theme }) => theme.inputLabel}55;
    box-sizing: border-box;
    width: 100%;
    height: 50%;
    top: 0;
    left: 0;
  }
`;

export const FieldMapItemList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  & li:last-child > div {
    border-left: none;
    &:before {
      border: solid ${({ theme }) => theme.inputLabel}55;
      border-width: 0 0 2px 2px;
    }
  }
  height: 0;
  ${({ expand }) => expand && css`
    height: 100%;
  `}
`;

export const FieldMapItem = styled.li`
  display: flex;
  flex-direction: row;
  margin-left: 20px;
`;

export const FieldMapItemBtn = styled.button`
  display: flex;
  flex-direction: row;
  width: 100%;
  border: none;
  font-size: 14px;
  text-align: start;
  padding: 2px 5px;
  color: ${({ theme }) => theme.inputLabel};
  background-color: transparent;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.card};
    color: ${({ theme }) => theme.grey};
  }
`;
